import React, { Component } from "react";
import IGetOrdersInPeriodByStatusDTO from "../../../../models/DTO/IGetOrdersInPeriodByStatusDTO";
import IOnGetOrdersInPeriodByStatusDTO from "../../../../models/DTO/IOnGetOrdersInPeriodByStatusDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IOrder from "../../../../models/IOrder";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import ReportPeriodType from "../../../../models/ReportPeriodTypeEnum";
import ReportTypeEnum from "../../../../models/ReportTypeEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import moment from "moment";
import * as _ from "lodash-es";
import "./OrdersCreated.scss";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import ReportPeriod from "../ReportPeriod/ReportPeriod";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    processedReport: IProcessed_Report;
};

type State = {
    orders: IOrder[];
    totalOrders: number;
};

export default class OrdersCreated extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        const data = this.props.processedReport.report_data as IOnGetOrdersInPeriodByStatusDTO;

        this.state = {
            orders: data.orders,
            totalOrders: data.totalOrders,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.ReportOnGetOrdersInPeriodByStatus, this.onGetOrdersInPeriodByStatus);

        // this.getOrdersInPeriodByStatus();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.ReportOnGetOrdersInPeriodByStatus, this.onGetOrdersInPeriodByStatus);
    }

    getOrdersInPeriodByStatus = () => {
        // let payload: IGetOrdersInPeriodByStatusDTO = {
        //     userGuid: this.props.userModel.guid,
        //     userToken: this.props.userModel.token,
        //     supplierGuid: this.props.supplierModel.guid,
        //     isPreliminary: this.props.onlyPreliminary,
        //     startDate: this.props.startDate,
        //     endDate: this.props.endDate,
        //     periodType: this.props.periodType,
        //     reportType: ReportTypeEnum.ORDERS_CREATED,
        // };
        //
        // this.props.socket.emit(EndpointsEnum.ReportGetOrdersInPeriodByStatus, payload);
    };

    onGetOrdersInPeriodByStatus = (data: IOnGetOrdersInPeriodByStatusDTO) => {
        data.orders = _.sortBy(data.orders, (order) => {
            return order.Vendor!.name;
        });

        this.setState({
            orders: data.orders,
            totalOrders: data.totalOrders,
        });
    };

    render() {
        return (
            <div className={"OrdersCreated"}>
                {/*<div className="row">*/}
                {/*    <OwTitle className={"col-12"} title={"orders_created_report"} />*/}
                {/*</div>*/}

                <ReportPeriod
                    className={"mt-3 mb-3"}
                    startDate={this.props.processedReport.period_start}
                    endDate={this.props.processedReport.period_end}
                />

                <div className={"mb-3 mt-3"}>
                    <OwLabel
                        title={"total_rows"}
                        isBold={true}
                        isUnderline={true}
                        postText={":"}
                        noBottomMargin={true}
                        className={"me-2"}
                    />
                    {this.state.totalOrders}
                </div>

                <div className={"row"}>
                    <div className={"col-4"}>
                        <OwLabel
                            title={"vendor"}
                            isBold={true}
                            isUnderline={true}
                            isSupplierVendorOverride={true}
                            supplierModel={this.props.supplierModel}
                        />
                    </div>
                    <div className={"col-4"}>
                        <OwLabel title={"name"} isBold={true} isUnderline={true} />
                    </div>
                    <div className={"col-4"}>
                        <OwLabel title={"created_at"} isBold={true} isUnderline={true} />
                    </div>
                </div>

                <div className={"data-rows"}>
                    {this.state.orders.map((order) => {
                        return (
                            <div key={order.guid} className={"row mb-2"}>
                                <div className={"col-4"}>{order.Vendor?.name}</div>
                                <div className={"col-4"}>{order.name}</div>
                                <div className={"col-4"}>{moment(order.created_at).format("MM/DD/YYYY")}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
